import { createContext, useContext } from "react";
import { createStore, useStore } from "zustand";
import { SearchResultProps } from "@/utils/types";

export interface SearchStoreProps {
	searchQuery: string;
	setSearchQuery: (searchQuery: string) => void;
	searchFocus: boolean;
	setSearchFocus: (searchFocus: boolean) => void;
	searchResults: SearchResultProps[] | null;
	setSearchResults: (searchResults: SearchResultProps[] | null) => void;
	showSearchResults: boolean;
	setShowSearchResults: (showSearchResults: boolean) => void;
	isSearching: boolean;
	setIsSearching: (isSearching: boolean) => void;
}

export const createSearchStore = () => {
	return createStore<SearchStoreProps>()((set) => ({
		searchQuery: "",
		setSearchQuery: searchQuery => set(() => ({ searchQuery })),
		searchFocus: false,
		setSearchFocus: searchFocus => set(() => ({ searchFocus })),
		searchResults: null,
		setSearchResults: searchResults => set(() => ({ searchResults })),
		showSearchResults: false,
		setShowSearchResults: showSearchResults => set(() => ({ showSearchResults })),
		isSearching: false,
		setIsSearching: isSearching => set(() => ({ isSearching })),
	}))
};

export type SearchStore = ReturnType<typeof createSearchStore>;

export const SearchContext = createContext<SearchStore | null>(null);

export function useSearchStore<T>(selector: (state: SearchStoreProps) => T): T {
	const store = useContext(SearchContext);
	if (!store) throw new Error("Missing SearchContext.Provider in the tree");
	return useStore(store, selector);
};